import React, { useState } from 'react';
import styled from 'styled-components';
import { useStaticQuery, graphql, Link } from 'gatsby';
import Img from 'gatsby-image';

import Wrapper from '../elements/wrapper';
import { media, TransitionMixin } from '../helpers';
import { useEffect } from 'react';

const PostsGridContainer = styled.div`
    .posts-wrapper {
        display: flex;
        flex-wrap: wrap;
        ${media.medium`max-width: 80vw;`}

        > * {
            flex: 0 0 33.33%;
            margin-bottom: 40px;
        }
    }

    .load-more-wrapper {
        text-align: center;
        padding: 40px 0 70px;

        button {
            color: #000;
            font-family: neue-kabel, sans-serif;
            font-weight: 800;
            background-color: transparent;
            border: none;
            padding: 0;
            font-size: 1.3rem;
            border-bottom: 2px solid #000;
            ${TransitionMixin('.25s')}

            &:hover {
                opacity: 0.7;
            }
        }
    }
`;

const PostsGrid = ({ category }) => {
    const data = useStaticQuery(graphql`
        query {
            posts: allWpPost {
                edges {
                    node {
                        title
                        excerpt
                        content
                        slug
                        featuredImage {
                            node {
                                localFile {
                                    childImageSharp {
                                        fluid(maxWidth: 1000) {
                                            ...GatsbyImageSharpFluid
                                        }
                                    }
                                }
                            }
                        }
                        categories {
                            nodes {
                                slug
                                name
                            }
                        }
                    }
                }
            }
        }
    `);

    const [postsIndex, setPostIndex] = useState(0);
    const [currentPosts, setCurrentPosts] = useState([]);
    const allPosts = data && data.posts.edges;

    useEffect(() => {
        // console.log('category', category);
        if (category) {
            let filteredPosts = [];
            allPosts.map((postEdge) => {
                let post = postEdge.node;
                post.categories.nodes.map((postCategory) => {
                    if (postCategory.slug === category.slug) {
                        filteredPosts.push(postEdge);
                    }
                    return;
                });
            });
            // console.log('filteredPosts', filteredPosts);
            setCurrentPosts(filteredPosts);
        } else {
            setCurrentPosts(allPosts);
        }
    }, []);

    return (
        <PostsGridContainer>
            <Wrapper className="posts-wrapper">
                {currentPosts &&
                    currentPosts.slice(0, postsIndex + 6).map((post, index) => {
                        return <PostGridItem post={post} key={index} />;
                    })}
            </Wrapper>
            <Wrapper className="load-more-wrapper">
                {postsIndex < currentPosts.length && (
                    <button onClick={() => setPostIndex(postsIndex + 3)}>
                        More Posts
                    </button>
                )}
            </Wrapper>
        </PostsGridContainer>
    );
};

const PostGridItemContainer = styled.div`
    display: flex;
    > .inner-wrap {
        max-width: 95%;
        margin: 0 auto;
        box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.2);
        position: relative;
        border: 1px solid #efefef;
        ${TransitionMixin('.25s')}

        &:hover {
            box-shadow: none;
        }

        a {
            text-decoration: none;

            .content-container {
                background-color: #fff;
                .inner-wrap {
                    padding: 40px 40px 100px;

                    h3 {
                        color: #000;
                    }

                    p {
                        color: #000;
                    }
                }
                .content-footer {
                    position: absolute;
                    bottom: 0;
                    padding: 15px 0;
                    background: red;
                    left: 0;
                    width: 100%;
                    padding-left: 15px;

                    &.branded {
                        background-color: #ff9905;
                    }
                    &.wedding {
                        background-color: #13a6ab;
                    }
                    &.impact {
                        background-color: #78781f;
                    }
                    &.products-and-design {
                        background-color: #f74d33;
                    }

                    p {
                        margin: 0;
                        color: #fff;
                        font-size: 0.9rem;
                    }
                }
            }
        }
    }
`;

export const PostGridItem = ({ post }) => {
    const { title, featuredImage, excerpt, slug, categories } = post.node || {};
    function removeTags(str) {
        if (str === null || str === '') return false;
        else str = str.toString();
        return str.replace(/(<([^>]+)>)/gi, '');
    }
    function truncate(str, no_words) {
        return str.split(' ').splice(0, no_words).join(' ') + '...';
    }
    let updatedExcerpt = removeTags(excerpt);
    updatedExcerpt = truncate(updatedExcerpt, 20);
    return (
        <PostGridItemContainer>
            <div className="inner-wrap">
                <Link to={`/blog/posts/${slug}`}>
                    <div className="image-container">
                        {featuredImage && (
                            <Img
                                fluid={
                                    featuredImage.node.localFile.childImageSharp
                                        .fluid
                                }
                            />
                        )}
                    </div>
                    <div className="content-container">
                        <div className="inner-wrap">
                            <h3>{title}</h3>
                            <p>{updatedExcerpt}</p>
                        </div>
                        <div
                            className={
                                'content-footer ' +
                                categories.nodes[0].slug.replace('blog-', '')
                            }
                        >
                            <p>{categories.nodes[0].name}</p>
                        </div>
                    </div>
                </Link>
            </div>
        </PostGridItemContainer>
    );
};

export default PostsGrid;
